import uiUxOne from "./assets/ui-ux-project-one.svg";
import uiUxTwo from "./assets/ui-ux-project-two.svg";
import uiUxThree from "./assets/ui-ux-project-three.svg";
import webOne from "./assets/web-project-one.jpeg";
import webTwo from "./assets/web-project-two.jpeg";
import webThree from "./assets/web-project-three.jpeg";

interface Project {
  id: number;
  category: string;
  img: string;
  title: string;
}

export const projects: Project[] = [
  {
    id: 0,
    category: "dotnet",
    img: uiUxOne,
    title: "Web Template",
  },
  {
    id: 1,
    category: "dotnet",
    img: uiUxTwo,
    title: "Tablet Template",
  },
  {
    id: 2,
    category: "dotnet",
    img: uiUxThree,
    title: "Solar System App",
  },
  {
    id: 3,
    category: "react",
    img: webOne,
    title: "Interior Design Website",
  },
  {
    id: 4,
    category: "react",
    img: webTwo,
    title: "Agency Landing Page",
  },
  {
    id: 5,
    category: "react",
    img: webThree,
    title: "Crypto Landing Page",
  },
  {
    id: 6,
    category: "python",
    img: uiUxTwo,
    title: "Data Ingestion",
  },
  {
    id: 7,
    category: "python",
    img: webThree,
    title: "Data Ingestion",
  },
  {
    id: 8,
    category: "python",
    img: webTwo,
    title: "Data Ingestion",
  },
];
